import { Component, OnInit } from '@angular/core';
import { AuthService } from "services/auth.service";

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.css']
})
export class AuthCallbackComponent implements OnInit {

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.authService.completeAuthentication();
  }

}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/auth-callback/auth-callback.component.ts